import { generateClient } from "aws-amplify/api";
import { get_ticket } from "@/graphql/queries";
import { edit_ticket, add_correspondence } from "@/graphql/mutations";
import { mapTicket } from "@/mixins/RCSSupport/TicketApi";

const client = generateClient();

export default {
  methods: {
    async apiGetTicket(ticketId) {
      const response = await client.graphql({
        query: get_ticket,
        variables: { input: { ticket_id: ticketId } },
      });
      const rawPayload = response.data.get_ticket;
      const responseData =
        typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;
      if (responseData.status == "SUCCESS") {
        const data = responseData.data || responseData;
        const ticket = data.ticket || data;
        let correspondence =
          data.correspondence ||
          data.messages ||
          ticket.correspondence ||
          ticket.messages ||
          [];
        if (typeof correspondence === "string") {
          try {
            correspondence = JSON.parse(correspondence);
          } catch {
            correspondence = [];
          }
        }
        if (!Array.isArray(correspondence)) {
          correspondence =
            correspondence?.items ||
            correspondence?.tickets ||
            correspondence?.messages ||
            [];
        }
        return mapTicket(ticket, correspondence);
      }
      throw new Error(responseData.status_message || "Failed to load ticket");
    },

    async apiAddCorrespondence(ticketId, message, attachments = []) {
      const input = { ticket_id: ticketId, message };
      if (attachments.length) {
        input.attachments = attachments;
      }
      const response = await client.graphql({
        query: add_correspondence,
        variables: { input },
      });
      const rawPayload = response.data.add_correspondence;
      const responseData =
        typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;
      if (responseData.status == "SUCCESS") return responseData;
      throw new Error(responseData.status_message || "Failed to add correspondence");
    },

    async apiUpdateTicketStatus(ticketId, newStatus, resolutionSummary) {
      const input = { ticket_id: ticketId, ticket_status: newStatus };
      if (resolutionSummary) input.resolution_summary = resolutionSummary;

      const response = await client.graphql({
        query: edit_ticket,
        variables: { input },
      });
      const rawPayload = response.data.edit_ticket;
      const responseData =
        typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;
      if (responseData.status == "SUCCESS") return responseData;
      throw new Error(responseData.status_message || "Failed to update ticket status");
    },

    async apiDeleteTicket(ticketId) {
      const input = { ticket_id: ticketId, ticket_status: "DEACTIVE" };
      const response = await client.graphql({
        query: edit_ticket,
        variables: { input },
      });
      const rawPayload = response.data.edit_ticket;
      const responseData =
        typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;
      if (responseData.status == "SUCCESS") return responseData;
      throw new Error(responseData.status_message || "Failed to delete ticket");
    },
  },
};
